import React from "react";
import { ArrowRight, BadgeCheck, Rocket, Sparkles, TriangleAlert, Wrench, X } from "lucide-react";

export const CATEGORY_META = {
  nuovo: { label: "NUOVO", icon: Sparkles, group: "Nuovo" },
  ai: { label: "AI", icon: Rocket, group: "Nuovo" },
  migliorato: { label: "MIGLIORATO", icon: Wrench, group: "Migliorato" },
  corretto: { label: "RISOLTO", icon: BadgeCheck, group: "Corretto" },
  importante: { label: "IMPORTANTE", icon: TriangleAlert, group: "Importante" },
};

export const releaseDate = value => value
  ? new Date(`${String(value).slice(0, 10)}T00:00:00`).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })
  : "";

export const ReleaseBadge = ({ category }) => {
  const meta = CATEGORY_META[category] || CATEGORY_META.nuovo;
  const Icon = meta.icon;
  return <span className={`release-badge ${category}`}><Icon size={11} />{meta.label}</span>;
};

export const ReleaseItem = ({ item, go, busy = false }) => <li className="release-item" data-testid={`release-item-${item.id}`}>
  <div className="release-item-head"><ReleaseBadge category={item.category} /><strong>{item.title}</strong></div>
  {item.description && <p>{item.description}</p>}
  {item.target && go && <button className="release-cta" disabled={busy} data-testid={`release-cta-${item.id}`} onClick={() => go(item.target === "quotes" ? "estimates" : item.target)}>
    {item.cta || "Scopri la funzione"}<ArrowRight size={14} />
  </button>}
</li>;

export const ReleaseDialog = ({ release, limit = 6, preview = false, busy = false, error = "", onClose, onAll, go }) => {
  if (!release) return null;
  const items = (release.items || []).slice(0, limit);
  const hidden = (release.items || []).length - items.length;
  return <div className="modal-backdrop release-backdrop" data-testid="release-backdrop">
    <div className={`release-modal ${release.important ? "important" : ""}`} role="dialog" aria-modal="true" aria-labelledby="release-heading" data-testid="release-dialog">
      <button className="modal-close" disabled={busy} aria-label="Conferma lettura e chiudi" data-testid="release-close" onClick={onClose}><X /></button>
      <div className="release-head">
        <span className="release-mark"><Rocket size={20} /></span>
        <div>
          <p className="eyebrow">{preview ? "ANTEPRIMA POPUP" : "NOVITÀ IN INGEGO"}</p>
          <h2 id="release-heading" data-testid="release-version">Versione {release.version}{release.date ? ` · ${releaseDate(release.date)}` : ""}</h2>
          <p className="release-lead">{release.title || "INGEGO si è aggiornato. Ecco cosa c'è di nuovo."}</p>
        </div>
      </div>
      {release.summary && <p className="release-summary">{release.summary}</p>}
      {release.important && <p className="release-warning" data-testid="release-important">Aggiornamento importante: modifica logiche operative, scadenze o documenti.</p>}
      <ul className="release-list">{items.map((item, index) => <ReleaseItem key={item.id || `item-${index}`} item={{ ...item, id: item.id || `item-${index}` }} go={preview ? null : go} busy={busy} />)}</ul>
      {hidden > 0 && <p className="muted release-more">e altre {hidden} novità in questa versione.</p>}
      <div className="release-actions">
        {onAll && <button className="ghost" disabled={busy} data-testid="release-see-all" onClick={onAll}>Vedi tutte le novità</button>}
        <button className="primary" disabled={busy} data-testid="release-confirm" onClick={onClose}>{busy ? "Salvataggio…" : release.important ? "Ho letto e compreso" : "Ho capito"}</button>
      </div>
      {error && <p className="error" role="alert" data-testid="release-confirm-error">{error}</p>}
    </div>
  </div>;
};
